/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SSRRuleListConfiguration,
    SSRRuleListConfigurationFromJSON,
    SSRRuleListConfigurationToJSON,
    SSRRuleListItem,
    SSRRuleListItemFromJSON,
    SSRRuleListItemToJSON,
    SSRRuleQuery,
    SSRRuleQueryFromJSON,
    SSRRuleQueryToJSON,
    SSRV2RuleDelete,
    SSRV2RuleDeleteFromJSON,
    SSRV2RuleDeleteToJSON,
    SSRV2RuleListConfiguration,
    SSRV2RuleListConfigurationFromJSON,
    SSRV2RuleListConfigurationToJSON,
    SSRV2RuleListItemPaginationWrapper,
    SSRV2RuleListItemPaginationWrapperFromJSON,
    SSRV2RuleListItemPaginationWrapperToJSON,
    SSRV2RuleQuery,
    SSRV2RuleQueryFromJSON,
    SSRV2RuleQueryToJSON,
    SSRV2RuleState,
    SSRV2RuleStateFromJSON,
    SSRV2RuleStateToJSON,
    SSRV2RuleStateResponse,
    SSRV2RuleStateResponseFromJSON,
    SSRV2RuleStateResponseToJSON,
} from '../models';

export interface ApiBookingCreateManagerSSRV2SSRRuleListDeleteRuleBulkDeleteRequest {
    sSRV2RuleDelete: Array<SSRV2RuleDelete>;
}

export interface ApiBookingCreateManagerSSRV2SSRRuleListListPostRequest {
    sSRV2RuleQuery?: SSRV2RuleQuery;
}

export interface ApiBookingCreateManagerSSRV2SSRRuleListUpdateStateBulkPostRequest {
    sSRV2RuleState: Array<SSRV2RuleState>;
}

export interface ApiSSRRuleListListPostRequest {
    sSRRuleQuery?: SSRRuleQuery;
}

/**
 * no description
 */
export class SSRRuleListApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleListDeleteRuleBulkDeleteRaw(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleListDeleteRuleBulkDeleteRequest): Promise<runtime.ApiResponse<Array<SSRV2RuleStateResponse>>> {
        if (requestParameters.sSRV2RuleDelete === null || requestParameters.sSRV2RuleDelete === undefined) {
            throw new runtime.RequiredError('sSRV2RuleDelete','Required parameter requestParameters.sSRV2RuleDelete was null or undefined when calling apiBookingCreateManagerSSRV2SSRRuleListDeleteRuleBulkDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/SSRV2/SSRRuleList/DeleteRuleBulk`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sSRV2RuleDelete.map(SSRV2RuleDeleteToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SSRV2RuleStateResponseFromJSON));
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleListDeleteRuleBulkDelete(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleListDeleteRuleBulkDeleteRequest): Promise<Array<SSRV2RuleStateResponse>> {
        const response = await this.apiBookingCreateManagerSSRV2SSRRuleListDeleteRuleBulkDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleListGetListConfigurationGetRaw(): Promise<runtime.ApiResponse<SSRV2RuleListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/SSRV2/SSRRuleList/GetListConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SSRV2RuleListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleListGetListConfigurationGet(): Promise<SSRV2RuleListConfiguration> {
        const response = await this.apiBookingCreateManagerSSRV2SSRRuleListGetListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleListListPostRaw(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleListListPostRequest): Promise<runtime.ApiResponse<SSRV2RuleListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/SSRV2/SSRRuleList/List`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SSRV2RuleQueryToJSON(requestParameters.sSRV2RuleQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SSRV2RuleListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleListListPost(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleListListPostRequest): Promise<SSRV2RuleListItemPaginationWrapper> {
        const response = await this.apiBookingCreateManagerSSRV2SSRRuleListListPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleListUpdateStateBulkPostRaw(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<SSRV2RuleStateResponse>>> {
        if (requestParameters.sSRV2RuleState === null || requestParameters.sSRV2RuleState === undefined) {
            throw new runtime.RequiredError('sSRV2RuleState','Required parameter requestParameters.sSRV2RuleState was null or undefined when calling apiBookingCreateManagerSSRV2SSRRuleListUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/SSRV2/SSRRuleList/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sSRV2RuleState.map(SSRV2RuleStateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SSRV2RuleStateResponseFromJSON));
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleListUpdateStateBulkPost(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleListUpdateStateBulkPostRequest): Promise<Array<SSRV2RuleStateResponse>> {
        const response = await this.apiBookingCreateManagerSSRV2SSRRuleListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSSRRuleListConfigurationGetRaw(): Promise<runtime.ApiResponse<SSRRuleListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SSRRuleList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SSRRuleListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiSSRRuleListConfigurationGet(): Promise<SSRRuleListConfiguration> {
        const response = await this.apiSSRRuleListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiSSRRuleListListPostRaw(requestParameters: ApiSSRRuleListListPostRequest): Promise<runtime.ApiResponse<Array<SSRRuleListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SSRRuleList/List`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SSRRuleQueryToJSON(requestParameters.sSRRuleQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SSRRuleListItemFromJSON));
    }

    /**
     */
    async apiSSRRuleListListPost(requestParameters: ApiSSRRuleListListPostRequest): Promise<Array<SSRRuleListItem>> {
        const response = await this.apiSSRRuleListListPostRaw(requestParameters);
        return await response.value();
    }

}
